import { render, staticRenderFns } from "./detail-folder.vue?vue&type=template&id=5fb22b18&scoped=true"
import script from "./detail-folder.vue?vue&type=script&lang=js"
export * from "./detail-folder.vue?vue&type=script&lang=js"
import style0 from "./detail-folder.vue?vue&type=style&index=0&id=5fb22b18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb22b18",
  null
  
)

export default component.exports